import LegalPage from "@/components/LegalPage";

const TermsConditions = () => (
  <LegalPage
    seoTitle="Terms & Conditions | Evaya Ventures"
    seoDescription="Terms and conditions governing the use of the Evaya Ventures website."
    path="/terms-conditions"
    title="Terms & Conditions"
    intro="These Terms & Conditions govern your use of the Evaya Ventures website. By using this website, you accept these terms."
    testId="terms-conditions-page"
    sections={[
      {
        heading: "About This Website",
        body: [
          "This website is published by Evaya Ventures to provide general information about the company, its focus areas and its development philosophy. Content on this website is for general informational purposes only.",
        ],
      },
      {
        heading: "No Offer or Solicitation",
        body: [
          "Nothing on this website constitutes an offer, invitation to offer, financial advice or a commitment of any kind. Any future development announced by Evaya Ventures will be governed by its own specific terms, documentation and applicable laws, including applicable real-estate regulations.",
        ],
      },
      {
        heading: "Accuracy of Information",
        body: [
          "We take care to keep the information on this website accurate and current. However, we make no representations or warranties of any kind about the completeness or accuracy of the content, and we may update or change content at any time without notice.",
        ],
      },
      {
        heading: "Intellectual Property",
        body: [
          "All content on this website — including text, design and branding — belongs to Evaya Ventures unless otherwise stated, and may not be reproduced without written permission.",
        ],
      },
      {
        heading: "Limitation of Liability",
        body: [
          "Evaya Ventures shall not be liable for any loss or damage arising from the use of, or reliance on, information presented on this website.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "For any questions regarding these Terms & Conditions, please contact us at [official email].",
        ],
      },
    ]}
  />
);

export default TermsConditions;
